export default __webpack_public_path__ + "cc8f9ae92254a3d7cb31c605c923a4f6.png";